<template>
  <vs-popup class="link-sage-supplier-pop-up"
            id="popup"
            :title="`LINK TO EXISTING SAGE SUPPLIER (${company_name})`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickLinkSageSupplier)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="sage_id" name="sage_id" rules="required" v-slot="{ errors }">
                <small class="label">Sage suppliers</small>
                <v-select :clearable="false" label="name" v-model="createForm.sage_id" :reduce="option => option.id" :options="sage_suppliers" :dir="$vs.rtl ? 'rtl' : 'ltr'"  @search="onSearch">
                  <template v-slot:option="option">
                    <span>{{option.name}}</span>
                  </template>
                  <template slot="no-options">
                    type to search sage supplier
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8 mb-0">
            <vs-button button="submit" class="ml-auto mt-2">Create</vs-button>
            <vs-button @click="open = false" class="ml-4 mt-2" type="border" color="warning">Close</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SageRepository = RepositoryFactory.get('sage')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";
  import SageHelper from '@/mixins/SageHelper'

  function initialState() {
    return {
      open: false,
      supplier_id: '',
      company_name: '',
      createForm: {},
      sage_suppliers: []
    }
  }

export default {
  name: 'LinkSageSupplierPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (supplier_id, company_name) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.supplier_id = supplier_id
        this.company_name = company_name

        // await this.fetchSageSuppliers()

        this.open = true;
      } catch (error) {

      }
    },

    // async fetchSageSuppliers() {
    //   this.$vs.loading()
    //   const vm = this
    //   try {
    //     vm.sage_suppliers =  (await SageRepository.getSageSuppliers()).data.data
    //   } catch (e) {
    //     vm.open = false
    //     if(e.response.status === 401 || e.response.status === 500) {
    //       this.showErrorMessageWithTitle('Error in sage', 'Authorization has been denied!')
    //       window.open('https://id.sage.com/authorize?audience=s200ukipd/sage200&client_id=7HyfIe66G922jQlQEv0UVdtY7XleXoe3&response_type=code&scope=openid offline_access&redirect=${window.location.origin}/pages/sage-verification&state=test_j_re_direct', '_blank');
    //     }
    //   }
    //   this.$vs.loading.close()
    // },

    async onClickLinkSageSupplier () {
      const vue = this;
      this.$vs.loading()
       try {
         await SageRepository.linkSageSupplier(this.supplier_id, this.createForm)
         this.showSuccessMessage('Sage supplier linked successfully')
         await vue.$parent.loadData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    onSearch: function (search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce( async (loading, search, vm) => {
      try {
        vm.sage_suppliers =  (await SageRepository.getSageSuppliers(`filter[name]=${search}`)).data.data
      } catch (e) {
        this.sageAuthHandler(e.response.status)
      }
      loading(false);
    }, 350),
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages, SageHelper],
}
</script>

<style scoped>
  .link-sage-supplier-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }
</style>
